// @flow

import _ from 'lodash';
import produce from 'immer';

import { actions } from 'client/constants';

export type UserType = {
	isVoted: boolean,
};

export type Action = {
	type: string,
	payload: any,
};

export const inititalUser: UserType = {
	isVoted: false,
};

export default function userReducer(state: UserType = inititalUser, { type, payload }: Action) {
	return produce(state, draft => {
		switch (type) {
			case actions.SET_IS_VOTED:
				_.set(draft, 'isVoted', payload.isVoted);
				break;

			default:
				break;
		}
	});
}
